import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Alert, Dialog, Link, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import { getOnlineSubscriptionDetail } from '@/services/utilService';
import useTable from '@/hooks/useTable';

export default function Online({ detail, clusterName }) {
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const loadData = useMemoizedFn(async () => {
    const { data } = await getOnlineSubscriptionDetail({
      clusterName,
      topic: detail.topic,
      subscriptionsName: detail.subscription,
    });
    setData(data);
  });

  const columns = [
    {
      colKey: 'consumerName',
      title: 'ConsumerName',
      width: 120,
    },
    {
      colKey: 'unackedMessages',
      title: 'UnackedMessages',
      width: 120,
    },
    {
      colKey: 'connectedSince',
      title: 'ConnectedSince',
      cell: ({ row }) => dayjs(row.connectedSince).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      colKey: 'address',
      title: 'Address',
      width: 120,
    },
  ];

  const { config, setData, doSearch } = useTable({
    columns,
    onSearch: loadData,
  });

  useEffect(() => {
    if (visible) {
      doSearch();
    }
  }, [visible, doSearch]);

  return (
    <>
      {detail.consumerOnlineCount > 0 ? (
        <Link theme='primary' onClick={() => setVisible(true)}>
          {detail.consumerOnlineCount}
        </Link>
      ) : (
        detail.consumerOnlineCount
      )}
      <Dialog
        header={
          <Header>
            在线个数
            <Tag>{clusterName}</Tag>
          </Header>
        }
        width={1000}
        footer={null}
        destroyOnClose
        onClose={onClose}
        onOverlayClick={onClose}
        visible={visible}
      >
        <Alert
          theme='info'
          style={{ marginBottom: 14 }}
          message='注意：订阅名称列表从分区角度展现了在线订阅信息，注意根据订阅名或客户端地址来区分'
        />
        <Table {...config} />
      </Dialog>
    </>
  );
}

const Header = styled.div`
  display: flex;
`;

const Tag = styled.div`
  background: rgba(102, 136, 255, 0.12);
  border-radius: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  padding: 2px 10px;
  color: #6688ff;
  margin-left: 12px;
`;
